import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useTranslate } from '@growtherapy/i18n';

import { useActiveBrand } from '../../components/branding/useActiveBrand';
import { ChatDrawerControlButton } from '../../session/controls/ChatDrawerControl';
import { VisitorDrawerState, visitorDrawerStateAtom } from '../state';
import { useChatDrawerButtonUtils } from './useChatDrawerButtonUtils';
import { setFaviconAndTitleBasedOnUnreadMessagesCount } from './utils';

export function ChatDrawerButtonWrapper({
  drawerId,
  onOpen,
  onClose,
  defaultTitle,
}: {
  drawerId: string;
  onOpen?: () => void;
  onClose?: () => void;
  defaultTitle?: string;
}) {
  const t = useTranslate();
  const { unreadMessagesCount, toggleChatDrawer, isChatDrawerDisabled } = useChatDrawerButtonUtils({ onOpen, onClose });
  const drawerState = useAtomValue(visitorDrawerStateAtom);
  const activeBrand = useActiveBrand();

  useEffect(
    function showUnreadChatNotificationInFaviconAndTitle() {
      // Provider no show title takes priority over chat notifications
      if (document.title === t('telehealth-core:meta.providerNotHere')) return;
      setFaviconAndTitleBasedOnUnreadMessagesCount(
        unreadMessagesCount,
        defaultTitle ?? t('telehealth-core:meta.growTherapyTelehealth'),
        activeBrand,
      );
    },
    [t, defaultTitle, unreadMessagesCount, activeBrand],
  );

  return (
    <ChatDrawerControlButton
      drawerId={drawerId}
      forDrawerStates={VisitorDrawerState.CHAT}
      isChatDrawerOpen={drawerState === VisitorDrawerState.CHAT}
      onClick={toggleChatDrawer}
      disabled={isChatDrawerDisabled}
      messageCount={unreadMessagesCount}
    />
  );
}
